export default __webpack_public_path__ + "static/media/fai_token_logo_blue.2b003ff1.png";